var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21C7 12.7157 13.7157 6 22 6C30.2843 6 37 12.7157 37 21C37 29.2843 30.2843 36 22 36C13.7157 36 7 29.2843 7 21ZM22.0001 13.1C22.4971 13.1 22.9001 13.5029 22.9001 14V20.1003H29C29.4971 20.1003 29.9 20.5032 29.9 21.0003C29.9 21.4973 29.4971 21.9003 29 21.9003H22.9001V28C22.9001 28.4971 22.4971 28.9 22.0001 28.9C21.503 28.9 21.1001 28.4971 21.1001 28V21.9003H15C14.503 21.9003 14.1 21.4973 14.1 21.0003C14.1 20.5032 14.503 20.1003 15 20.1003H21.1001V14C21.1001 13.5029 21.503 13.1 22.0001 13.1Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.fffdd3784713c69c2a1584c4c5400a52.svg";
export { ForwardRef as ReactComponent };